export default __webpack_public_path__ + "static/media/logo.017b9460.svg";